export default __webpack_public_path__ + "static/media/download_white.94142960.svg";